import { actionTypes } from "../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: []
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
